import { z } from 'zod';
import * as C from './content.js';
import * as L from './lists.js';
import * as S from './shop.js';
import * as X from './special.js';
export * from './base.js';
export * from './content.js';
export * from './lists.js';
export * from './shop.js';
export * from './special.js';
/**
 * Barcha 31 blok turi. `type` maydoni bo'yicha discriminated union —
 * Zod noto'g'ri turdagi `data` ni darhol rad etadi.
 *
 * Yangi blok qo'shish = 3 ta fayl (docs/03-CONVENTIONS.md §7):
 *   1. shu papkada sxema
 *   2. apps/admin/.../blocks/<Type>Editor.tsx
 *   3. apps/web/.../blocks/<Type>Block.tsx
 */
export const blockSchema = z.discriminatedUnion('type', [
    // Umumiy (15)
    C.heroSliderBlock,
    C.pageHeaderBlock,
    C.richTextBlock,
    C.textImageBlock,
    C.statsBlock,
    C.featuresBlock,
    C.galleryBlock,
    C.videoBlock,
    C.faqBlock,
    C.accordionBlock,
    C.timelineBlock,
    C.partnersBlock,
    C.ctaBlock,
    C.mapBlock,
    C.htmlBlock,
    // Ro'yxatlar (7)
    L.newsListBlock,
    L.servicesListBlock,
    L.projectsListBlock,
    L.staffListBlock,
    L.documentsListBlock,
    L.coursesListBlock,
    L.servicesPriceBlock,
    // Do'kon (5)
    S.productsGridBlock,
    S.productSliderBlock,
    S.categoriesGridBlock,
    S.brandsStripBlock,
    S.productCompareBlock,
    // Maxsus (4)
    X.droneshowPackagesBlock,
    X.droneshowPortfolioBlock,
    X.requestFormBlock,
    X.contactInfoBlock,
]);
/** Admin panelning «Blok qo'shish» modalidagi guruhlar (Design D4). */
export const BLOCK_GROUPS = {
    Umumiy: [
        'hero-slider',
        'page-header',
        'rich-text',
        'text-image',
        'stats',
        'features',
        'gallery',
        'video',
        'faq',
        'accordion',
        'timeline',
        'partners',
        'cta',
        'map',
        'html',
    ],
    "Ro'yxatlar": [
        'news-list',
        'services-list',
        'projects-list',
        'staff-list',
        'documents-list',
        'courses-list',
        'services-price',
    ],
    "Do'kon": [
        'products-grid',
        'product-slider',
        'categories-grid',
        'brands-strip',
        'product-compare',
    ],
    Boshqa: ['droneshow-packages', 'droneshow-portfolio', 'request-form', 'contact-info'],
};
/** Barcha blok turlari ro'yxati — validatsiya va testlar uchun. */
export const BLOCK_TYPES = Object.values(BLOCK_GROUPS).flat();
/** Faqat `superadmin` qo'sha oladigan bloklar (TZ 4.2). */
export const RESTRICTED_BLOCK_TYPES = ['html'];
export const blocksArraySchema = z.array(blockSchema).max(40);
//# sourceMappingURL=index.js.map